module.exports = __webpack_public_path__ + "static/media/image_34.16971ba7.png";